import { useEffect, lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import "@/App.css";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { Packages } from "@/components/site/Packages";
import { Why, Marquee } from "@/components/site/Why";
import { Area } from "@/components/site/Area";
import { Commitment, CTA } from "@/components/site/Commitment";
import { Footer, FloatingWa } from "@/components/site/Footer";
import { FiberDivider } from "@/components/site/Fiber";

const BillingApp = lazy(() => import("@/billing/BillingApp"));
const isBillingHost = window.location.hostname.startsWith("billing.");

function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={null}>
        <Routes>
          {isBillingHost ? (
            <Route path="/*" element={<BillingApp base="" />} />
          ) : (
            <>
              <Route path="/billing/*" element={<BillingApp base="/billing" />} />
              <Route path="*" element={<Website />} />
            </>
          )}
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

function Website() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, anchors: { offset: -80 } });
    let id;
    const raf = (t) => { lenis.raf(t); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); };
  }, []);

  return (
    <div className="App overflow-x-clip">
      <Navbar />
      <main>
        <Hero />
        <FiberDivider testId="fiber-divider-1" />
        <Packages />
        <Why />
        <Marquee />
        <Area />
        <FiberDivider testId="fiber-divider-2" />
        <Commitment />
        <FiberDivider testId="fiber-divider-3" dark />
        <CTA />
      </main>
      <Footer />
      <FloatingWa />
    </div>
  );
}

export default App;
